import { useMemo } from 'react'
import { useLocation } from 'react-router'

export default function useQueryParams(names) {
    const location = useLocation()

    return useMemo(() => {
        const searchParams = new URLSearchParams(location.search)
        return names.map(name => searchParams.get(name))
    }, [location.search, names])
}
